/*
 * 桌号管理设置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:45:01
 * @Last Modified by: fan.lion@foxmail.com
 * @Last Modified time: 2020-02-10 11:59:24
 */

const api = {
	downloadTableQRCodes: '/table/downloadTableQRCodes'
};

const routes = {
	'/table-manage': '桌号管理',
};

export {
	api,
	routes,
};
